import 'bootstrap/js/carousel';

$(function() {
    // Add the Link to see All products
    let category = (<any>window).analyticsData.page.category1DimensionId;
    let subcat = (<any>window).analyticsData.page.pageTitle
        .replace(/ /g, '_')
        .replace('&', 'And')
        .replace("'", '')
        .replace('?', '')
        .replace('!', '')
        .replace('.', '')
        .replace('%', 'percent');

    if (typeof category !== 'undefined') {
        $('.sellAllProducts').attr(
            'href',
            '/pages/productresults?nav=n:' + category.replace(' ', '_') + '&ic=' + subcat + '_SBP_ALLProducts',
        );
    }

    //tablet
    $('.MainColumn .ShopByBrand .shopbybrand-footer').on('click', goToBrandPage);

    //mobile
    $('.MainColumn .ShopByBrand #allBrandsCollapsable').on('click', goToBrandPage);

    arrangeNavigation();
    function arrangeNavigation() {
        //Registering Click event for each link lists' 'SeeAll' in the main content area.
        $('.Middle .MainColumn .refinementmenu .dvSeeAll').click(function() {
            $('.Middle .MainColumn .refinementmenu .dvSeeLess:visible').click();
            let outerHeight = $(this)
                .closest('.refinementmenu')
                .outerHeight();
            let outerWidth = $(this)
                .closest('.refinementmenu')
                .outerWidth();
            $(this)
                .closest('.refinementmenu div.cartridge')
                .css({
                    position: 'absolute',
                    'background-color': '#fff',
                    width: outerWidth - 10 + 'px',
                    'border-bottom': '5px solid #000',
                    'border-left': '1px solid #eeefe1',
                    'border-right': '1px solid #eeefe1',
                    'box-shadow': '6px 7px 10px 0px rgba(0,0,0,0.12)',
                    'z-index': '1',
                });
            $(this)
                .closest('.refinementmenu')
                .outerHeight(outerHeight);
            $(this)
                .siblings('ul')
                .children()
                .show('fast');
            $(this)
                .siblings('.dvSeeLess')
                .show();
            $(this).hide();
        });

        //Registering Click event for each link lists' 'SeeLess' in the main content area.
        $('.Middle .MainColumn .refinementmenu  .dvSeeLess').click(function() {
            let visiblenumber: number = parseInt(
                $(this)
                    .siblings('.section-header')
                    .attr('visiblenumber'),
            );
            $(this)
                .siblings('ul')
                .children(':gt(' + (visiblenumber - 2) + ')')
                .hide();
            $(this)
                .closest('.refinementmenu div.cartridge')
                .css({
                    'border-left': '1px solid #fff',
                    'border-right': '1px solid #fff',
                    'border-bottom': '0',
                    'box-shadow': 'none',
                    'z-index': '0',
                });
            $(this)
                .siblings('.dvSeeAll')
                .show();
            $(this).hide();
        });

        //Registering Click event for each link lists' 'SeeAll' in the left content area.
        $('.GuidedNavigation_LeftContent .dvSeeAll').click(function() {
            $('.GuidedNavigation_LeftContent .dvSeeLess:visible').click();
            $(this)
                .siblings('ul')
                .children()
                .show('fast');
            $(this)
                .siblings('.dvSeeLess')
                .show();
            $(this).hide();
        });

        //Registering Click event for each link lists' 'SeeLess' in the left content area.
        $('.GuidedNavigation_LeftContent .dvSeeLess').click(function() {
            let visiblenumber: number = parseInt(
                $(this)
                    .siblings('.section-header')
                    .attr('visiblenumber'),
            );
            $(this)
                .siblings('ul')
                .children(':gt(' + (visiblenumber - 1) + ')')
                .hide();
            $(this)
                .siblings('.dvSeeAll')
                .show();
            $(this).hide();
        });

        let prevLinkControl;
        let wrapper = $("<div class='mainColumnLinksContainer hidden-md hidden-lg hidden-xs'></div>");
        let toBeDeletetedWrappers = [];
        $('.Middle .MainColumn .quicklinks,.Middle .MainColumn .GuidedNavigation_MainContent')
            .parent('.ContentSlot_MainContent')
            .each(function(index) {
                let isQuickLink = $(this).find('.quicklinks').length > 0;
                if (index > 0) {
                    if (
                        !$(this)
                            .prev()
                            .is(prevLinkControl)
                    ) {
                        wrapper = $("<div class='mainColumnLinksContainer hidden-md hidden-lg hidden-xs'></div>");
                        $(this).before(wrapper);
                    }
                } else {
                    $(this).before(wrapper);
                }
                if (isQuickLink) {
                    wrapper.append($(this).find('.quicklinks'));
                } else {
                    $(this)
                        .find('.refinementmenu')
                        .each(function() {
                            wrapper.append($(this));
                        });
                }
                prevLinkControl = $(this);
                toBeDeletetedWrappers.push(prevLinkControl);
            });
        $(toBeDeletetedWrappers).each(function() {
            $(this).remove();
        });
    }

    arrangeNavigationForMobile();
    function arrangeNavigationForMobile() {
        let collapsablePanelTemplate = `<div class="category-navlinks-wrapper panel-group"  aria-multiselectable="true">
                                            <div class="panel">
                                                <div class="panel-heading collapsed"  role="button" data-toggle="collapse" data-target="#categoryNavLinksContent">
                                                    <span class="section-header"   />
                                                    <svg class="svgIconAccordion">
                                                        <use xlink:href="/dist/svg.svg#arrow-drop-down" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                    </svg>
                                                </div>
                                                <div class="panel-collapse collapse" role="tabpanel" id="categoryNavLinksContent">
                                                    <div class="panel-body">
                                                        <ul class="category-navlinks-list">
                                
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>`;

        $('.mainColumnLinksContainer').each(function(index) {
            let collapsablePanelContainer = $(`<div class="clearfix category-navlinks visible-xs"></div>`);
            $('.quicklinks,.refinementmenu', $(this)).each(function(innerIndex) {
                let menuTitle = $(this)
                    .find('.section-header')
                    .text();
                let lstMenuLinks = $(this)
                    .find('ul li')
                    .clone()
                    .show();
                let menuPanel = $(collapsablePanelTemplate)
                    .find('.section-header')
                    .text(menuTitle)
                    .end();
                menuPanel.find('ul').append(lstMenuLinks);
                menuPanel
                    .find('.panel-heading')
                    .attr('data-target', '#categoryNavLinksContent' + index + '-' + innerIndex);
                menuPanel.find('.panel-collapse').attr('id', 'categoryNavLinksContent' + index + '-' + innerIndex);
                $(collapsablePanelContainer).append(menuPanel);
            });
            $(this).before(collapsablePanelContainer);
        });
    }
});

function goToBrandPage() {
    let url = $(this)
        .find('.section-header')
        .attr('url');
    window.location.href = url;
}
